<div class="info-panel-container"
     [style.top]="top"
     [style.left]="left"

>


    <div class="keep-dialog-open-area-top-extender" (mouseleave)="close()" (click)="onKeepDialogOpenAreaClicked()"
         (mousemove)="onMouseMove($event)">
        <div class="keep-dialog-open-area-right-extender" (mouseleave)="close()" (click)="$event.stopPropagation()"
             (mousemove)="onMouseMove($event)">
            <div class="info-panel"  #infoPanel>
                <div class="table">
                    <div class="table-header">
                        <div>Anz.</div>
                        <div>Artikelnr.</div>
                        <div>Bezeichnung</div>
                    </div>
                    <div class="table-body">
                        <div class="table-row" *ngFor="let device of model.project.devices">
                            <div>{{device.count}}</div>
                            <div>{{device.modelNumber}}</div>
                            <div>{{device.modelTitle}}</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

</div>





